import { RiBookLine, RiCodeView, RiPresentationLine, RiVideoFill, RiVideoLine } from '@remixicon/react'
import React from 'react'
import SlideUp from '../../utlits/animations/slideUp'

const Resume = () => {
    return (
        <section id="resume" className="resume-area">
            <div className="container">
                <div className="resume-items">
                    <div className="row">
                        <div className="col-xl-6 col-md-6">
                            <div className="single-resume">
                                <h2>Experiencia laboral</h2>
                                <div className="experience-list">
                                    <Card icon={<RiPresentationLine size={30} />}year={'jul 2024 - actualidad'} title={'Responsable de Marketing'} institution={'VISCO'} />
                                    <Card icon={<RiCodeView size={30} />} year={'sep 2022 - actualidad'} title={'Desarrollador Fullstack'} institution={'AYANET TIC'} />
                                    <Card icon={<RiVideoLine size={30} />} year={'ago 2013 - ago 2023'} title={'Creador de contenido'} institution={'YouTube'} />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6">
                            <div className="experience-list">
                                <div className="single-resume">
                                    <h2>Formación académica</h2>
                                    <Card icon={<RiCodeView size={30} />} year={'2021 - 2023'} title={'Desarrollador de Aplicaciones Multiplataforma'} institution={'CPIFP Los Enlaces'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Resume


const Card = ({ icon, year, title, institution }) => {
    return (
        <SlideUp>
            <div className="resume-item">
                <div className="icon">
                    {icon}
                </div>
                <div className="content">
                    <span className="years">{year}</span>
                    <h4>{title}</h4>
                    <span className="company"> {institution} </span>
                </div>
            </div>
        </SlideUp>
    )
}